export const intervalToSeconds = (interval: { days?: number; hours?: number; minutes?: number; seconds?: number }) => {
  const daysInSeconds = (interval.days || 0) * 86400
  const hoursInSeconds = (interval.hours || 0) * 3600
  const minutesInSeconds = (interval.minutes || 0) * 60
  const seconds = interval.seconds || 0

  return daysInSeconds + hoursInSeconds + minutesInSeconds + seconds
}
